export const FlatType = {
  OFFICE: 'оф',
}
